import {
    useCallback,
} from 'react'
import {
    RequestKeys,
} from 'app/hooks/useRequest'
import {
    useGetRequestSpreadSheetAdapter,
} from 'app/shared-components/SkyNetSpreadSheet'
import StatusHandler from 'app/shared-components/StatusHandler'
import {
    AsyncMutationOptions,
} from 'app/types/request.types'
import useFilter from 'app/hooks/useFilter'
import {
    useSkyNetPagination, SkyNetPaginationContext,
} from 'app/shared-components/SkyNetPagination'
import requests from 'app/requests/RateCard/RateCard.requests'
import useSimpleApiRequest from 'app/hooks/useSimpleApiRequest'
import defaultRateCardsSort from 'app/Apps/Rates/Rates.utils'

import {
    OtherLaneFeesEditable,
    OtherLaneFeesTable,
} from '../OtherLaneFees.types'
import OtherLaneFeesSpreadsheet from '../OtherLaneFeesSpreadsheet'
import {
    prepareFeesToBulkEdit,
} from '../OtherLaneFees.utils'

export default function OtherLaneFeesBulkEdit({
    onClose,
}: {
    onClose: () => void
}) {
    const filterOptions = useFilter<OtherLaneFeesTable[]>()
    const paginationOptions = useSkyNetPagination(100)
    const {
        isError,
        loaded,
        error,
        refetch,
    } = useGetRequestSpreadSheetAdapter<OtherLaneFeesTable>({
        config: requests.otherLaneFeesFilterRequest,
        requestKey: RequestKeys.getOtherLaneFees,
        enabled: true,
        filterOptions,
        paginationOptions,
        defaultSort: defaultRateCardsSort,
    })

    const {
        mutateAsync: bulkEdit,
    } = useSimpleApiRequest<{ items: OtherLaneFeesEditable[] }>({
        name: 'OtherFeesBulkUpdate',
        title: 'Other Standard Lane Fees were updated',
        requestParams: requests.otherLaneFeesBulkEdit(),
        onSuccess: refetch,
    })

    const onSave = useCallback(async (
        items: OtherLaneFeesTable[],
        options?: AsyncMutationOptions,
    ) => {
        await bulkEdit({
            items: prepareFeesToBulkEdit<OtherLaneFeesTable, OtherLaneFeesEditable>(items),
        }, {
            ...options,
            onSuccess: options?.onSuccess || onClose,
        })
    }, [
        bulkEdit,
        onClose,
    ])

    return (
        <StatusHandler
            isError={isError}
            isFetching={!loaded}
            error={error}
            isSuccess={loaded}
        >
            <SkyNetPaginationContext.Provider value={paginationOptions}>
                <OtherLaneFeesSpreadsheet
                    filterOptions={filterOptions}
                    onCancel={onClose}
                    onSave={onSave}
                />
            </SkyNetPaginationContext.Provider>
        </StatusHandler>
    )
}
